/**
 * Constants for EmailEntryPage component
 */

export const EMAIL_VALIDATION_MESSAGES = {
  REQUIRED: 'Email address is required!',
  INVALID: 'Please enter a valid email address',
  ALREADY_REGISTERED: "We've met before! Log into your proposal here.",
  ERROR: 'An error occurred. Please try again.',
} as const

export const BUTTON_STATES = {
  DEFAULT: 'Continue',
  LOADING: 'Checking...',
} as const

export const QUIZ_RESPONSES = {
  EMAIL_CHECK: 'EMAIL_CHECK',
} as const
